import React from 'react'

export const UsersIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.6 6.4C6.48366 6.4 7.2 5.68366 7.2 4.8C7.2 3.91634 6.48366 3.2 5.6 3.2C4.71634 3.2 4 3.91634 4 4.8C4 5.68366 4.71634 6.4 5.6 6.4Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.8 6.4C9.68366 6.4 10.4 5.68366 10.4 4.8C10.4 3.91634 9.68366 3.2 8.8 3.2C7.91634 3.2 7.2 3.91634 7.2 4.8C7.2 5.68366 7.91634 6.4 8.8 6.4Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.6 12.8C5.6 11.0327 6.83273 9.8 8.6 9.8C10.3673 9.8 11.6 11.0327 11.6 12.8"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.4 12.8C2.4 11.0327 3.63273 9.8 5.4 9.8"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
